import { Trans } from '@lingui/macro'
import React, { FC, useState } from 'react'
import { TagBeta } from '../../../../components'
import { Select } from 'front-end/src/components'
import { OrganisationCalendars } from '../../../../graphql/public/PublicSchemaTypes'
import { GoogleCalendarIntegration } from './GoogleCalendarIntegration'
import { MSGraphIntegration } from './MSGraphIntegration'

export enum CalendarIntegrationEnum {
  MSOUTLOOK = 'MSOUTLOOK',
  GOOGLE = 'GOOGLE'
}

const INTEGRATION_OPTIONS = [
  {
    value: 'disabled',
    label: 'Disabled'
  },
  {
    value: CalendarIntegrationEnum.GOOGLE,
    label: 'Google Calendar'
  },
  {
    value: CalendarIntegrationEnum.MSOUTLOOK,
    label: 'Microsoft Outlook'
  }
]

export const defaultIntegrationOption = (calendars: OrganisationCalendars) => {
  if (!!calendars?.google?.calendarId) {
    return CalendarIntegrationEnum.GOOGLE
  }
  if (!!calendars?.msgraph?.accountName) {
    return CalendarIntegrationEnum.MSOUTLOOK
  }
  return 'disabled'
}

export type CalendarIntegrationsProps = {
  calendars: OrganisationCalendars
  calendarsRefetch: () => Promise<any>
  msAuthUrl?: string | null
}

export const CalendarIntegrations: FC<CalendarIntegrationsProps> = ({
  calendars,
  calendarsRefetch,
  msAuthUrl
}) => {
  const defaultIntegration = defaultIntegrationOption(calendars)
  const [selectedIntegration, setSelectedIntegration] = useState<
    CalendarIntegrationEnum | 'disabled'
  >(defaultIntegration)

  return (
    <div className="AccountPage__box">
      <h4>
        <Trans>Calendar integrations</Trans> <TagBeta />
      </h4>
      <p className="text-description">
        <Trans>
          Show and manage the events created in Looop with events in your team's
          calendar. The events will show on users' own calendars when they are
          invited.
        </Trans>
      </p>
      <div className="AccountPage__checkBoxWrapper">
        <Select
          options={INTEGRATION_OPTIONS}
          value={INTEGRATION_OPTIONS.find(
            ({ value }) => selectedIntegration === value
          )}
          isDisabled={defaultIntegration !== 'disabled'}
          onChange={(opt) => setSelectedIntegration(opt?.value)}
        />
      </div>
      {selectedIntegration === CalendarIntegrationEnum.GOOGLE && (
        <GoogleCalendarIntegration
          calendars={calendars}
          calendarsRefetch={calendarsRefetch}
        />
      )}
      {selectedIntegration === CalendarIntegrationEnum.MSOUTLOOK && (
        <MSGraphIntegration
          calendars={calendars}
          calendarsRefetch={calendarsRefetch}
          msAuthUrl={msAuthUrl}
        />
      )}
    </div>
  )
}
